// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".nuxt-link-active[data-v-0f1d5849]{--tw-bg-opacity:1;--tw-bg-opacity:0.1;background-color:rgba(5,63,141,.1);background-color:rgba(5,63,141,var(--tw-bg-opacity))}.nuxt-link-active+hr[data-v-0f1d5849]{visibility:hidden}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
